import Cookies from 'js-cookie';
import { useAppSelector } from './redux';
import { formatNumber } from '@/utils';

export const useUserInfo = () => {
  const { info, walletInfo, supportInfo } = useAppSelector((state) => state.user);
  const loggedIn = Cookies.get('access-token');
  const mainWallet = walletInfo?.find((item) => item?.type?.toLowerCase() === 'main');
  const bonusWallet = walletInfo?.find((item) => item?.type?.toLowerCase() === 'bonus');
  const bonusBalance = Number(bonusWallet?.amount ?? 0) - Number(bonusWallet?.exposureAmount ?? 0);

  const mainBalance =
    Number(mainWallet?.amount ?? 0) - Math.abs(Number(mainWallet?.exposureAmount ?? 0));
  const withdrawableBalance = mainBalance - Number(mainWallet?.lockedAmount ?? 0);
  const lockedBalance = Number(mainWallet?.lockedAmount ?? 0);
  const isDemoAccount = info?.role?.name?.toLowerCase() === 'demo';
  const username = isDemoAccount ? 'DEMO' : (info?.username ?? '');
  const exposureBalance = Number(mainWallet?.exposureAmount ?? 0);
  const mobileNumber = info?.mobile ?? '';
  const whatsappSupport = supportInfo?.whatsapp ?? '';
  const DOB = info?.DOB ?? '';
  const userId = info?.id ?? '';
  const referralCode = info?.referralCode ?? '';

  return {
    username,
    loggedIn,
    mainBalance: formatNumber(mainBalance),
    withdrawableBalance: formatNumber(withdrawableBalance),
    exposureBalance: formatNumber(exposureBalance),
    isDemoAccount,
    mobileNumber,
    bonusBalance: formatNumber(bonusBalance),
    lockedBalance: formatNumber(lockedBalance),
    whatsappSupport,
    DOB,
    userId,
    referralCode,
  };
};
